<!-- 网站首页 -->
<template>
  <div class="group" v-if="sellStatusID===2||sellStatusID===3">
    <div v-if="type==='pc'" class="p_diamond bg_DC000C font_12">
      {{ sellStatusID===2?$t('goods.sellstatus_yushou'):sellStatusID===3?$t('goods.sellstatus_xianhuo'):'' }}
    </div>
    <div v-if="type==='pc2'" class="p_diamond2 bg_DC000C font_12">
      {{ sellStatusID===2?$t('goods.sellstatus_yushou'):sellStatusID===3?$t('goods.sellstatus_xianhuo'):'' }}
    </div>
    <div v-if="type==='h5'" class="p_diamond_h5 bg_DC000C font_12">
      {{ sellStatusID===2?$t('goods.sellstatus_yushou'):sellStatusID===3?$t('goods.sellstatus_xianhuo'):'' }}
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      type: {
        type: String,
        default: 'pc'
      },
      sellStatusID: {
        type: Number,
        default: 0
      }
    },
    methods: {}
  }
</script>

<style scoped="scoped">
  .group {
    display: inline-block;
  }

  .p_diamond2,
  .p_diamond {
    display: inline-block;
    min-width: 58px;
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    margin-left: 10px;
    -webkit-transform: skew(-20deg);
    -moz-transform: skew(-20deg);
    -o-transform: skew(-20deg);
    -ms-transform: skew(-20deg);
    transform: skew(-20deg);
    text-align: center;
    font-size: 14px;
    color: #fff;
    font-weight: 800;
    position: relative;
    top: -40px;
  }

  .p_diamond2 {
    top: -20px !important;
  }

  .p_diamond_h5 {
    display: inline-block;
    min-width: 58px;
    padding: 0 5px;
    height: 25px;
    line-height: 25px;
    border-radius: 4px;
    margin-left: 10px;
    -webkit-transform: skew(-20deg);
    -moz-transform: skew(-20deg);
    -o-transform: skew(-20deg);
    -ms-transform: skew(-20deg);
    transform: skew(-20deg);
    text-align: center;
    color: #fff;
    font-weight: 800;
  }
</style>



// WEBPACK FOOTER //
// src/components/public-statuscard/public-statuscard.vue